module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("If you are looking to disable Two Factor Authentication, please confirm your password and Click Disable 2FA Button.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control col-md-4",
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "Current Password",
      "name": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.disableGoogle2fa
    }
  }, [_vm._v("\n    Disable 2FA\n    "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bee112a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/accountSettings/Google2FA/DisableGoogle2FA.vue
// module id = 982
// module chunks = 0